/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Meeting_Offline_Recording_PillInputs */



/**
* | output |
* | --- |
* | "Recording · {time}" |
*
* @param {Meeting_Offline_Recording_PillInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_recording_pill = /** @type {((inputs: Meeting_Offline_Recording_PillInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Recording_PillInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Opname · ${i?.time}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Enregistrement · ${i?.time}`)
	return /** @type {LocalizedString} */ (`Recording · ${i?.time}`)
});